import "./style.css";
export const Loader = ({ isLoading }) => {
  return (
    isLoading && (
      <div class="loader-container">
        <div class="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div class="loading-text">Loading...</div>
        </div>
      </div>
    )
  );
};
